module.exports = __webpack_public_path__ + "img/ueberdachung_2.f8250527.webp";